import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Clear old demo_ keys from localStorage on app startup (only if new keys don't exist)
if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
  // Only clear old keys if we don't have the new ones yet
  if (!localStorage.getItem('user') && localStorage.getItem('demo_user')) {
    localStorage.removeItem('demo_user');
  }
  if (!localStorage.getItem('session') && localStorage.getItem('demo_session')) {
    localStorage.removeItem('demo_session');
  }
  console.log('[App] Cleaned up old localStorage keys (demo_user, demo_session)');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
